import { MutationTree } from 'vuex';
import { ILieferantenState } from './state';
import {
    LieferantDokumentApiDto,
    TvsKundeListApiDto,
    TvsKundeVonZugriffeApiDto,
    TvsLieferantFehlerhafteRechnungApiDto,
    TvsLieferantRechnungApiDto,
    TvsLieferantRechnungDetailApiDto
} from '@/api-schema';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';
import { LieferantenDokumentFilterDto } from '@/types/LieferantenDokumentFilterDto';
import { TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE } from '@/areas/administration/store/mutations';

export const MAPRECHNUNGEN = 'mapLieferantenRechnungen';
export const ADDRECHNUNGEN = 'addDokumentToList';
export const MAPRECHNUNGDETAIL = 'mapRechnungsDetails';
export const CLEARFILTER = 'clearFilter';
export const APPLYFILTER = 'mapRechnungFilter';
export const LOADING = 'mapLoading';
export const TOTAL_NUMBER_OF_RECORDS = 'mapTotalNumberOfRecords';
export const OFFSET = 'mapOffset';
export const MAP_TVS_KUNDEN_FOR_FILTER = 'mapTvsKundenForFilter';
export const OFFSET_TVS_KUNDEN = 'mapTvsKundenOffset';
export const MAP_TVS_KUNDEN = 'mapTvsKunden';
export const ADD_TVS_KUNDEN_LIST = 'addTvsKundenList';
export const LOADING_TVS_KUNDEN = 'mapTvsKundenLoading';
export const CLEAR_TVS_KUNDEN_FILTER = 'clearTvsKundenFilter';
export const APPLY_TVS_KUNDEN_FILTER = 'mapTvsKundenFilter';
export const TOTAL_NUMBER_OF_RECORDS_TVS_KUNDEN = 'mapTotalNumberOfRecordsTvsKunden';
export const CLEAR_LIEFERANTENDOKUMENT_FILTER = 'clearLieferantenDokumentFilter';
export const APPLY_LIEFERANTENDOKUMENT_FILTER = 'mapLieferantenDokumentFilter';
export const MAP_LIEFERANTEN_DOKUMENTE = 'mapLieferantenDokumente';
export const ADD_LIEFERANTEN_DOKUMENTE = 'addLieferantenDokumente';
export const OFFSET_DOKUMENTE = 'mapDokumenteOffset';
export const LOADING_DOKUMENTE = 'mapDokumenteLoading';
export const MAP_FEHLERHAFTE_RECHNUNGEN = 'mapFehlerhafteLieferantenRechnungen';
export const ADD_FEHLERHAFTE_RECHNUNGEN = 'addFehlerhafteLieferantenRechnungen';
export const MAPLIEFERANTBENUTZERDATA = 'mapLieferantBenutzerData';
export const MAP_LIEFERANT_DETAILS = 'mapLieferantDetails';
export const MAP_TVS_KUNDE_DETAILS = 'mapTvsKundeDetails';
export const MAP_UNITS_OF_MEASUREMENT = 'mapUnitsOfMeasurement';
export const MAP_MWST_SATZ_LIST = 'mapMwstSatzList';

export const mutations: MutationTree<ILieferantenState> = {
    [MAPRECHNUNGEN](state, value: Array<TvsLieferantRechnungApiDto>) {
        state.rechnungList = value;
    },
    [ADDRECHNUNGEN](state, value: Array<TvsLieferantRechnungApiDto>) {
        state.rechnungList = state.rechnungList.concat(value);
    },
    [MAPRECHNUNGDETAIL](state, value: Array<TvsLieferantRechnungDetailApiDto>) {
        state.rechnungenDetails = value;
    },
    [APPLYFILTER](state, value: RechnungFilterDto) {
        state.rechnungFilter = value;
    },
    [CLEARFILTER](state) {
        state.rechnungFilter = new RechnungFilterDto();
    },
    [TOTAL_NUMBER_OF_RECORDS](state, value: number) {
        state.totalNumberOfRecords = value;
    },
    [OFFSET](state, value: number) {
        state.rechnungFilter.offset = value;
    },
    [LOADING](state, value: boolean) {
        state.loading = value;
    },
    [MAP_TVS_KUNDEN_FOR_FILTER](state, values: Array<TvsKundeVonZugriffeApiDto>) {
        const result: Array<object> = [];
        values.forEach((val) => {
            console.log('mapping values:' + val.anzeigeNamen, +' ' + val.teilnehmerId);
            result.push({ title: val.anzeigeNamen, value: val.teilnehmerId });
        });
        state.tvsKundenVonLieferant = result;
    },
    [LOADING_TVS_KUNDEN](state, value: boolean) {
        state.tvsKundenLoading = value;
    },
    [OFFSET_TVS_KUNDEN](state, value: number) {
        state.tvsKundenFilter.offset = value;
    },
    [TOTAL_NUMBER_OF_RECORDS_TVS_KUNDEN](state, value: number) {
        state.tvsKundenTotalNumberOfRecords = value;
    },
    [MAP_TVS_KUNDEN](state, value: Array<TvsKundeListApiDto>) {
        state.tvsKundenListe = value;
    },
    [ADD_TVS_KUNDEN_LIST](state, value: Array<TvsKundeListApiDto>) {
        state.tvsKundenListe = state.tvsKundenListe.concat(value);
    },
    [CLEAR_TVS_KUNDEN_FILTER](state) {
        state.tvsKundenFilter = new TeilnehmerFilterDto();
    },
    [APPLY_TVS_KUNDEN_FILTER](state, value: TeilnehmerFilterDto) {
        state.tvsKundenFilter.status = value.status;
        state.tvsKundenFilter.suchText = value.suchText;
        state.tvsKundenFilter.hatRechnungenNurViaVetdata = value.hatRechnungenNurViaVetdata;
        state.tvsKundenFilter.hatTvsDokumenteNurDigital = value.hatTvsDokumenteNurDigital;
        state.tvsKundenFilter.suchText = value.suchText;
        state.tvsKundenFilter.sortBy = value.sortBy;
        state.tvsKundenFilter.sortOrder = value.sortOrder;
        state.tvsKundenFilter.offset = 0;
    },
    [TOTAL_NUMBER_OF_RECORDS_LIEFERANTEN_DOKUMENTE](state, value: number) {
        state.lieferantenDokumenteTotalNumberOfRecords = value;
    },
    [MAP_LIEFERANTEN_DOKUMENTE](state, value: Array<LieferantDokumentApiDto>) {
        state.lieferantenDokumentList = value;
    },
    [ADD_LIEFERANTEN_DOKUMENTE](state, value: Array<LieferantDokumentApiDto>) {
        state.lieferantenDokumentList = state.lieferantenDokumentList.concat(value);
    },
    [OFFSET_DOKUMENTE](state, value: number) {
        state.lieferantenDokumentFilter.offset = value;
    },
    [LOADING_DOKUMENTE](state, value: boolean) {
        state.dokumenteLoading = value;
    },
    [APPLY_LIEFERANTENDOKUMENT_FILTER](state, value: LieferantenDokumentFilterDto) {
        state.lieferantenDokumentFilter = value;
        state.lieferantenDokumentFilter.offset = 0;
    },
    [MAP_FEHLERHAFTE_RECHNUNGEN](state, value: Array<TvsLieferantFehlerhafteRechnungApiDto>) {
        state.fehlerhafteRechnungList = value;
    },
    [ADD_FEHLERHAFTE_RECHNUNGEN](state, value: Array<TvsLieferantFehlerhafteRechnungApiDto>) {
        state.fehlerhafteRechnungList = state.fehlerhafteRechnungList.concat(value);
    },
    [MAP_LIEFERANT_DETAILS](state, data) {
        state.lieferantDetailData = data;
    },
    [MAP_TVS_KUNDE_DETAILS](state, data) {
        state.tvsKundeDetails = data;
    },
    [MAP_UNITS_OF_MEASUREMENT](state, data) {
        state.unitsOfMeasurement = data;
    },
    [MAP_MWST_SATZ_LIST](state, data) {
        state.mwstSatzList = data;
    }
};
